import { useEffect, useRef, useState } from "react";
import axios from "axios";
import Config from "../components/axios/Config";
import Cookie from "js-cookie";
import SwalToast from "../components/helpers/SwalToast";
import Template from "../components/Template";
import Navbar from "../components/Navbar";
import ErrorDiv from "../components/helpers/ErrorDiv";
import Select from "react-select";
import ReactDatatable from "@mkikets/react-datatable";
import Modal from 'react-bootstrap/Modal'
import { CanAccess, AuthorizationList } from '../components/Authorization';
import NumberFormat from "react-number-format";
import update from 'immutability-helper'
import { IsFamilyNameAutoGenerated, ShowFamilyName } from "../components/UtilsGoat";

/**
 * 
 * @param {function} onSuccess when data is successfully saved
 * @returns 
 */
const AddEdit = ({ onSuccess, record }) => {
    const [id, set_id] = useState(null)
    const [name, set_name] = useState('')
    const [long_code, set_long_code] = useState('')
    const [short_code, set_short_code] = useState('')

    const [submitting, set_submitting] = useState(false)
    const [errors, set_errors] = useState({})

    useEffect(() => {
        if (record) {
            set_id(record.id)
            set_name(record.name)
            set_long_code(record.long_code || "")
            set_short_code(record.short_code || "")
        }
    }, [record])

    const validate = () => {
        let errors = {}
        let validate = true;

        if (!name) {
            validate = false;
            errors.name = "Name is required"
        }
        if (long_code !== "" && long_code.length > 5) {
            validate = false;
            errors.long_code = "Full Blood Code should be empty or has max length of 5"
        }
        if (short_code !== "" && short_code.length !== 2) {
            validate = false;
            errors.short_code = "Cross Boer Code should be empty or has length of 2"
        }

        set_errors(errors)
        return validate
    }

    const saveFamilyName = (e) => {
        e.preventDefault()
        if (!validate()) return;

        let data = {
            id: id,
            name: name,
            long_code: long_code || null,
            short_code: short_code || null,
        }
        set_submitting(true)
        axios.post(`${process.env.REACT_APP_BASE_API_URL}family-name/saveData`, data, Config({
            Authorization: 'Bearer ' + Cookie.get('token'),
        })).then(res => {
            SwalToast.fire({ icon: 'success', title: res.data.message })
            onSuccess()
        }).catch((error) => {
            console.log(error)
            let errMsg = 'Whoops, something went wrong!'
            if (error.response?.data) {
                errMsg = error.response.data.message
            }
            SwalToast.fire({ icon: 'error', title: errMsg })
        }).finally(() => {
            set_submitting(false)
        })
    }

    return (
        <div className="">
            <div className="form-group">
                <label htmlFor="name">Name</label>
                <input required id="name" type="text" className="form-control" placeholder="Name" value={name} onChange={e => set_name(e.target.value)} />
                <ErrorDiv error={errors.name} />
            </div>
            <div className="form-group">
                <label htmlFor="long_code">Full Blood Code (Max Length: 5 | Optional)</label>
                <input required id="long_code" type="text" className="form-control" placeholder="Full Blood Code" value={long_code} onChange={e => set_long_code(e.target.value)} />
                <ErrorDiv error={errors.long_code} />
            </div>
            <div className="form-group">
                <label htmlFor="short_code">Cross Boer Code (Length: 2 | Optional)</label>
                <input required id="short_code" type="text" className="form-control" placeholder="Cross Boer Code" value={short_code} onChange={e => set_short_code(e.target.value)} />
                <ErrorDiv error={errors.short_code} />
            </div>
            <div className="mt-3 d-flex float-right">
                <button onClick={saveFamilyName} type="submit" disabled={submitting} className="btn bgc-8CC73F shadow-graph text-white font-weight-bold ml-2">Save</button>
            </div>
        </div>
    )
}
const FamilyName = () => {
    const [records, set_records] = useState([])
    const [total, set_total] = useState(0)
    const [datatable, set_datatable] = useState({})
    const [filter, set_filter] = useState(null)
    const [search, set_search] = useState(null)

    const [current_record, set_current_record] = useState(null)

    const [modal_show_save, set_modal_show_save] = useState(false)
    const [modal_show_delete, set_modal_show_delete] = useState(false)
    const [modal_show_change_status, set_modal_show_change_status] = useState(false)
    const [modal_show_update_counter, set_modal_show_update_counter] = useState(false)
    const [submitting, set_submitting] = useState(false)

    const alreadyInit = useRef(false)

    useEffect(() => {
        getData()
    }, [filter])

    useEffect(() => {
        if (!alreadyInit.current) return;

        let timeout = setTimeout(() => {
            getData(datatable)
        }, 500);

        return () => {
            clearTimeout(timeout)
        }
    }, [search])

    const columns = [
        {
            key: "id",
            text: "ID",
        },
        {
            key: "name",
            text: "Name",
            cell: record => (
                ShowFamilyName(record)
            )
        }, {
            key: "long_code",
            text: "Full Blood Code"
        }, {
            key: "short_code",
            text: "Cross Boer Code"
        }, {
            key: "counter",
            text: "Current Counter",
            cell: (record) => (<>
                {record.counter}
            </>)
        },
        {
            key: "action",
            text: "Action",
            cell: (record) => (<div className="d-flex">
                {!IsFamilyNameAutoGenerated(record) && <>
                    <CanAccess role={AuthorizationList.master_data_family_name_save} yes={<div
                        className="link font-weight-bold color-374650 mr-3"
                        onClick={() => openModalEdit(record)}
                    >Edit</div>} />
                    <CanAccess role={AuthorizationList.master_data_family_name_delete} yes={<div
                        className="link font-weight-bold color-374650 mr-3"
                        onClick={() => openModalDelete(record)}
                    >Delete</div>} />
                    <CanAccess role={AuthorizationList.master_data_family_name_save} yes={<div
                        className={`link font-weight-bold ${record.is_active ? "color-EB2424" : "color-0C9344 "} mr-3`}
                        onClick={() => openModalChangeStatus(record)}
                    >{record.is_active ? "Disable" : "Enable"}</div>} />
                </>}
                <div
                    className={`link font-weight-bold color-374650}`}
                    onClick={() => openModalUpdateCounter(record)}
                >Update Counter</div>
            </div>)
        }
    ];
    const config = {
        page_size: 10,
        length_menu: [10, 20, 50],
        show_filter: true,
        show_pagination: true,
        pagination: 'advance',
        button: {
            excel: false,
            print: false
        }
    };
    const filters = [
        {
            value: "asc",
            label: "Sort By: Date Added ASC"
        }, {
            value: "desc",
            label: "Sort By: Date Added DESC"
        }
    ];

    const openModalAdd = () => {
        set_modal_show_save(true)
        set_current_record(null)
    }

    const openModalEdit = (record) => {
        set_modal_show_save(true)
        set_current_record(record)
    }

    const openModalDelete = (record) => {
        set_modal_show_delete(true)
        set_current_record(record)
    }
    const closeModalDelete = () => {
        set_modal_show_delete(false)
    }

    const openModalChangeStatus = (record) => {
        set_modal_show_change_status(true)
        set_current_record(record)
    }
    const closeModalChangeStatus = () => {
        set_modal_show_change_status(false)
    }

    const openModalUpdateCounter = (record) => {
        set_modal_show_update_counter(true)
        set_current_record(record)
    }
    const closeModalUpdateCounter = () => {
        set_modal_show_update_counter(false)
    }

    const deleteColor = (e) => {
        e.preventDefault()
        if (!current_record) return;

        set_submitting(true)
        axios.delete(`${process.env.REACT_APP_BASE_API_URL}family-name/${current_record.id}`, Config({
            Authorization: 'Bearer ' + Cookie.get('token'),
        })).then(res => {
            SwalToast.fire({ icon: 'success', title: res.data.message })
            closeModalDelete()
            getData(datatable)
        }).catch((error) => {
            console.log(error)
            let errMsg = 'Whoops, something went wrong!'
            if (error.response?.data) {
                errMsg = error.response.data.message
            }
            SwalToast.fire({ icon: 'error', title: errMsg })
        }).finally(() => {
            set_submitting(false)
        })
    }
    const changeStatus = (e) => {
        e.preventDefault()
        if (!current_record) return;

        let data = {
            is_active: !current_record.is_active
        }

        set_submitting(true)
        axios.post(`${process.env.REACT_APP_BASE_API_URL}family-name/changeStatus/${current_record.id}`, data, Config({
            Authorization: 'Bearer ' + Cookie.get('token'),
        })).then(res => {
            SwalToast.fire({ icon: 'success', title: res.data.message })
            closeModalChangeStatus()
            getData(datatable)
        }).catch((error) => {
            console.log(error)
            let errMsg = 'Whoops, something went wrong!'
            if (error.response?.data) {
                errMsg = error.response.data.message
            }
            SwalToast.fire({ icon: 'error', title: errMsg })
        }).finally(() => {
            set_submitting(false)
        })
    }
    const updateCounter = (e) => {
        e.preventDefault()
        if (!current_record) return;

        if (current_record.counter === "") return;
        if (current_record.counter < 0) return;

        let data = {
            counter: current_record.counter
        }

        set_submitting(true)
        axios.post(`${process.env.REACT_APP_BASE_API_URL}family-name/updateCounter/${current_record.id}`, data, Config({
            Authorization: 'Bearer ' + Cookie.get('token'),
        })).then(res => {
            SwalToast.fire({ icon: 'success', title: res.data.message })
            closeModalUpdateCounter()
            getData(datatable)
        }).catch((error) => {
            console.log(error)
            let errMsg = 'Whoops, something went wrong!'
            if (error.response?.data) {
                errMsg = error.response.data.message
            }
            SwalToast.fire({ icon: 'error', title: errMsg })
        }).finally(() => {
            set_submitting(false)
        })
    }

    const getData = (datatable = null) => {
        let params = {
            search: search,
            filter: filter?.value || '',
            length: datatable?.page_size || config.page_size,
            // column: data?.sort_order?.column || '',
            // dir:data?.sort_order?.order || '',
            page: datatable?.page_number || 1
        }
        axios.get(`${process.env.REACT_APP_BASE_API_URL}family-name/getWithParams`, Config({
            Authorization: 'Bearer ' + Cookie.get('token'),
        }, params)).then(res => {
            set_datatable(datatable)
            set_records(res.data.data.data)
            set_total(res.data.data.total_item)
            alreadyInit.current = true
        }).catch((error) => {
            console.log(error)
            let errMsg = 'Whoops, something went wrong!'
            if (error.response?.data) {
                errMsg = error.response.data.message
            }
            SwalToast.fire({ icon: 'error', title: errMsg })
        })
    }

    const onSaveSuccess = () => {
        set_modal_show_save(false)
        getData(datatable)
    }

    const onChangeCurrentCounter = ({ floatValue }) => {
        set_current_record(update(current_record, {
            counter: { $set: floatValue }
        }))
    }

    return (
        <Template>
            <style jsx="true">{`
                    #as-react-datatable-table-head {
                        display: none;
                    }
                    thead {
                        background-color: #95A4AF;
                        color: white;
                    }
                `}</style>
            <Navbar>
                <h4 className="m-0 color-374650 font-weight-bold">Marga</h4>
            </Navbar>
            <div className="p-3">
                <div className="row">
                    <div className="col-3">
                        <Select
                            isClearable
                            options={filters}
                            className="w-100"
                            value={filter}
                            onChange={set_filter}
                            placeholder={"Sort By:"}
                        />
                    </div>
                    <div className="col-4">
                        <input
                            type="text"
                            className="form-control"
                            placeholder={"Search here"}
                            value={search}
                            onChange={(e) => set_search(e.target.value)}
                        />
                    </div>
                    <div className="col-5 d-flex justify-content-end">
                        <div>
                            <CanAccess role={AuthorizationList.master_data_family_name_save} yes={
                                <button onClick={openModalAdd} className="btn bgc-374650 shadow-graph text-white font-weight-bold" >
                                    Add Family Name
                                </button>
                            } />
                        </div>
                    </div>
                </div>
                <div className="mt-4">
                    <ReactDatatable
                        config={config}
                        records={records}
                        columns={columns}
                        dynamic={true}
                        total_record={total}
                        onChange={getData}
                    />
                </div>
            </div>

            <Modal size="l" centered show={modal_show_save} onHide={() => set_modal_show_save(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>{current_record ? "Edit" : "Add"} Family Name</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <AddEdit onSuccess={onSaveSuccess} record={current_record} />
                </Modal.Body>
            </Modal>

            <Modal size="l" centered show={modal_show_change_status} onHide={closeModalChangeStatus}>
                <Modal.Header closeButton>
                    <Modal.Title>Change Status</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div >
                        <div className="mx-auto my-auto">Are You sure you want to {current_record?.is_active ? "Disable" : "Enable"} this data ?</div>
                    </div>
                    <div className="mt-3 d-flex float-right">
                        <button onClick={closeModalChangeStatus} className="btn bgc-95A4AF shadow-graph text-white font-weight-bold ml-2">Cancel</button>
                        <button onClick={changeStatus} type="submit" disabled={submitting} className="btn bgc-EB2424 shadow-graph text-white font-weight-bold ml-2">Confirm</button>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal size="l" centered show={modal_show_delete} onHide={closeModalDelete}>
                <Modal.Header closeButton>
                    <Modal.Title>Delete Family name</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="mx-auto my-auto">Are you sure you want to delete {current_record?.name}?</div>
                    <div className="mt-3 d-flex float-right">
                        <button onClick={closeModalDelete} className="btn bgc-95A4AF shadow-graph text-white font-weight-bold ml-2">Cancel</button>
                        <button onClick={deleteColor} type="submit" disabled={submitting} className="btn bgc-EB2424 shadow-graph text-white font-weight-bold ml-2">Confirm Delete</button>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal size="l" centered show={modal_show_update_counter} onHide={closeModalUpdateCounter}>
                <Modal.Header closeButton>
                    <Modal.Title>Update Counter</Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    <div className="form-group">
                        <label htmlFor="short_code">Current Counter</label>
                        <NumberFormat type="text" className="form-control" placeholder={"Current Counter"}
                            thousandSeparator={true} decimalSeparator={false} allowNegative={false}
                            value={current_record?.counter} onValueChange={onChangeCurrentCounter}
                        />
                    </div>
                    <div className="mt-3 d-flex float-right">
                        <button onClick={closeModalUpdateCounter} className="btn bgc-95A4AF shadow-graph text-white font-weight-bold ml-2">Cancel</button>
                        <button onClick={updateCounter} type="submit" disabled={submitting} className="btn bgc-EB2424 shadow-graph text-white font-weight-bold ml-2">Update Counter</button>
                    </div>
                </Modal.Body>
            </Modal>
        </Template>
    );
}

export default FamilyName;
